var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value || _vm.value == 0)?_c('div',[_vm._v(_vm._s(_vm.value))]):_c('v-skeleton-loader',{class:_vm.sceletonClass,attrs:{"max-width":_vm.sceletonMaxWidth,"min-width":_vm.sceletonMinWith,"type":_vm.sceletonType}})}
var staticRenderFns = []

export { render, staticRenderFns }